'use client';

import dynamic from 'next/dynamic';

/*
 * Content embeds loaded only by the articles that contain them. As plain imports they came with
 * every article: the tutorial slider alone added Swiper's CSS (3 render-blocking files and an icon
 * font) to all posts. The split only works from a client module (from a server component the CSS
 * still joins the whole route). They are still rendered on the server, so their HTML is unchanged
 * where they appear.
 */
export const ExchangeTutorial = dynamic(
    () => import('@/components/(postTypes)/platforms/(single)/layout/ExchangeTutorial'),
);
export const VideoPlayer = dynamic(() => import('@/components/VideoPlayer'));
